/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CollectedService } from '../../models/collected-service';

export interface GetCollectedServicesForCientAndDateIdDateGet$Plain$Params {
  id_client?: number;
  date: string;
  id: string;
}

export function getCollectedServicesForCientAndDateIdDateGet$Plain(http: HttpClient, rootUrl: string, params: GetCollectedServicesForCientAndDateIdDateGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CollectedService>>> {
  const rb = new RequestBuilder(rootUrl, getCollectedServicesForCientAndDateIdDateGet$Plain.PATH, 'get');
  if (params) {
    rb.query('id_client', params.id_client, {});
    rb.path('date', params.date, {});
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<CollectedService>>;
    })
  );
}

getCollectedServicesForCientAndDateIdDateGet$Plain.PATH = '/GetCollectedServicesForCientAndDate/{id}/{date}';
